import { render, staticRenderFns } from "./StackedBarStats.vue?vue&type=template&id=53be416b"
import script from "./StackedBarStats.vue?vue&type=script&lang=js"
export * from "./StackedBarStats.vue?vue&type=script&lang=js"
import style0 from "./StackedBarStats.vue?vue&type=style&index=0&id=53be416b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports